import IUser from "interface/user/user-interface"

export default function getDirectEmployees(employees: IUser[], manager: IUser) {
    return employees.filter((user: IUser) =>
        user?.statusInfo.directManager === manager?.securityInfo?.email &&
        user?._id !== manager?._id
    )
}